
import React from 'react'
import { Field } from 'react-final-form'
import { urlImages } from 'config'
import { handleFocus, handleBlur } from '../AnimationHandler'
import InputMask from 'react-input-mask'

function Input({ name, type, label, inputRef, tooltip, active = false, withAnimate = true, validate = false, mask = null }) {

	const renderControl = (input) => {
			const onFocus=(e) => {
				if(withAnimate)
					handleFocus(e) 
					
				input.onFocus(e)
			}

			const onBlur = (e) => {
				if(withAnimate)
					handleBlur(e, input) 
					
				input.onBlur(e)
			}

			if(mask) {
				return (
					<InputMask mask={mask} value={input.value} onChange={input.onChange} onFocus={onFocus} onBlur={onBlur}>
						<input 
							type={type} 
							name={name} 
							id={name} 
							className="float-input" 
						/>
					</InputMask>
				)
			}

			return <input 
				{...input} 
				type={type} 
				name={name} 
				id={name} 
				className="float-input" 
				value={input.value}
				onBlur={onBlur}
				onFocus={onFocus}
				ref={inputRef}
			/>
	}

	const renderTooltip = () => {
		if(tooltip !== undefined) {
			return (
				<button type="button" className="btn-help" 
						data-toggle="tooltip" 
						data-html="true" 
						title="">
						<img src={urlImages + "/images/icons/help-icon.svg"} alt="" />
				</button>
			)
		}
	}

	const renderError = ({touched, data: { error: metaErrro}, submitting}) => {
		if((metaErrro) && (touched || submitting)) {
			return (
				<div className="field-error-message">
					{ metaErrro }
				</div>
			)
		}
	}

	return (
		<Field name={name}>
			{({ input, meta }) => {
				return (
						<>
						<div 
							className={"float-container " + 
								((meta.data.error) && (meta.touched || meta.submitting)
									? 'error' : '')+(input.value != '' || meta.active || active ? ' active' : '')
							}
						>
							{label && <label htmlFor={name}>{ label }</label>}
							{ renderControl(input) }
							{ renderTooltip() }
							
						</div>
						{ renderError(meta) }
						</>
				)
			}}
		</Field>
	)

}

export default Input;
